import Header from '../Parts/Header/Header';
import Footer from '../Parts/Footer/Footer';
import Toast from '../Components/Notifications/toast/Toast';
import './layouts.css';

function Layouts(props) {
  const { children } = props;
  return (
    <section className="layout">
      <Toast text="Get 15% off your first order - Use promo code: MERISEHAT" />
      <Header />
      {children}
      <Footer />
    </section>
  );
}

export default Layouts;
